<template>
  <div>
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent='backBtn' class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
          <h1>{{$t(`${'MyPage.setting'}`)}}</h1>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
  },
  methods: {
    backBtn () {
      history.back()
    }
  }
}
</script>
